module.exports = __webpack_public_path__ + "static/img/team-bg.485965d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/team-bg.png
// module id = DF6a
// module chunks = 36